export default __webpack_public_path__ + "static/media/linkedin.4b68ccee.svg";